export enum MonitorType {
  website_status_monitor = "Website status monitor",
  web_presence_monitor = "Web presence monitor",
}
